module.exports = __webpack_public_path__ + "static/media/fruits.7a0c69a7.jpeg";